import { render, staticRenderFns } from "./LolLeaderboard.vue?vue&type=template&id=4947227c&"
import script from "./LolLeaderboard.vue?vue&type=script&lang=js&"
export * from "./LolLeaderboard.vue?vue&type=script&lang=js&"
import style0 from "./LolLeaderboard.vue?vue&type=style&index=0&id=4947227c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports